import UploadEarning from './upload-earning';

export default UploadEarning;